import React, { useEffect, useRef, useState } from "react";
import "./ChatAI.scss";
import { ConversationProps } from "../../types/chat-bot-hub/ConversationProps";
import TypingLoader from "./TypingLoader";
import { MessageData } from "../../types/chat-bot-hub/MessageData";

type MessageGroups = {
  [date: string]: MessageData[];
};

const Conversation: React.FC<ConversationProps> = ({messages,sendTextToChatBot, responseCompleted}) => {
  const [localInputText, setLocalInputText] = useState<string>("");
  const [localIsProcessing,setLocalIsProcessing]= useState(false);
  const [messageGroups,setMessageGroups] = useState<MessageGroups>({});
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    //if (responseCompleted) {
      setLocalIsProcessing(!responseCompleted);
    //}
  }, [responseCompleted]);
  useEffect(()=>{
    setMessageGroups(groupMessagesByDate());
  },[messages]);
  // Helper function to format date as a readable string (e.g., "Today", "Yesterday", or "Jan 15, 2024")
const formatDateHeader = (timestamp: string) => {
  const date = new Date(timestamp);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  // Reset time part for comparison
  today.setHours(0, 0, 0, 0);
  yesterday.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  
  if (date.getTime() === today.getTime()) {
    return "Today";
  } else if (date.getTime() === yesterday.getTime()) {
    return "Yesterday";
  } else {
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  }
};

// Helper function to get date string (YYYY-MM-DD) from timestamp
const getDateString = (timestamp: string) => {
  const date = new Date(timestamp);
  return date.toISOString().split('T')[0];
};
 // Group messages by date
const groupMessagesByDate = () => {
  const groups: { [date: string]: typeof messages } = {};
  console.log(messages);
  messages.forEach(msg => {
    if (msg.questions && msg.questions.timeStamp) {
      const dateKey = getDateString(msg.questions.timeStamp.toString());
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(msg);
    }
  });
  
  return groups;
};


  const formatTimestamp = (date: Date) => {
  return new Date(date).toLocaleString("en-US", {
    weekday: "short", 
    hour: "numeric",  
    minute: "2-digit", 
    hour12: true      
  });
  };
    const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
            setLocalInputText(event.target.value); 
        }

     const handleClick = () => {
      
      sendTextToChatBot(messages.find(m => m.sessionId != null && m.sessionId != "")?.sessionId?? "", localIsProcessing,localInputText);  
      setLocalIsProcessing(!localIsProcessing);
      setLocalInputText('');   
        };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
          event.preventDefault(); 
          handleClick(); 
        }
      };

  return (
    <>
           <div className="h-100">
          <div className="chat-box">
  {Object.entries(messageGroups).map(([dateKey, messagesInGroup]) => (
    <div key={dateKey}>
      <div className="text-center my-3">
      <span className="px-3 py-1 text-muted" style={{ 
        fontWeight: 'normal',
        fontSize: '0.875rem'
      }}>
        {formatDateHeader(messagesInGroup[0].questions.timeStamp.toString())}
      </span>
    </div>
      
      {/* Messages for this date */}
      {messagesInGroup.map((m, i) => (
        <div key={i}>
          {/* Request */}
          {m.questions && m.questions.text !== "" && (
            <div className="media ml-auto mb-3 justify-content-end max-w">
              <div className="d-flex flex-column align-items-end">
                <div className="bg-primary mb-1 custom-chat chat-sender">
                  <div className="text-small mb-0 text-white">
                    {m.questions.text}
                  </div>
                </div>
                <p className="timestamp text-muted mb-0">
                  {formatTimestamp(m.questions.timeStamp)}
                </p>
              </div>
            </div>
          )}

          {/* Result */}
          {m.answers && m.answers.length > 0 && (
            <div className="media max-w mb-3">
              <div className="ml-3">
                <div className="bg-light mb-1 custom-chat chat-reciever">
                  <div className="flex flex-col gap-2 text-small mb-0 text-muted">
                    {m.answers.map((r, j) => (
                      <p key={j} style={{ whiteSpace: 'pre-line' }}>{r.text}</p>
                    ))}
                  </div>
                </div>
                <p className="text-muted timestamp text-left" style={{ marginLeft: "22px" }}>
                  {formatTimestamp(m.answers[m.answers.length-1].timeStamp)}
                </p>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  ))}
</div>
        <form action="#" className="message-input">
          {localIsProcessing && <TypingLoader/>}
      <div ref={wrapperRef} className="mt-4 relative">
        <div className="d-flex align-items-center rounded-pill shadowsm typingarea bg-white">
          <input
            type="text"
            value={localInputText}
            className="form-control border-0 shadow-none ms-2 bg-transparent"
            placeholder="Ask anything....."
            onChange={handleInput}
            onKeyDown={handleKeyDown}
            disabled = {localIsProcessing}
          />
          <button
            type="button"
            className="btn rounded-circle d-flex align-items-center justify-content-center me-1 chatbtn"
            onClick={handleClick}
            disabled = {localIsProcessing}
          >
            <i className="bi bi-arrow-up text-white"></i>
            {/* {!localIsProcessing ?<i className="bi bi-arrow-up text-white"></i> :
            <i className="bi bi-stop-circle text-white"></i>} */}
          </button>
        </div>
      </div>
    </form>
   </div>
    </>
  );
};

export default Conversation;
